import React, { useState, useEffect } from 'react';
import { Row, Col, Spin, Alert, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import StatisticsApiService from '../../services/StatisticsApiService';
import OverviewStatsCards from './OverviewStatsCards';
import CoursesByCategoryCompactChart from './CoursesByCategoryCompactChart';
import CategoryBarChart from './CategoryBarChart';
import TrendLineChart from './TrendLineChart';
import CategoryDataTable from './CategoryDataTable';

const StatisticsDashboard = () => {
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStatistics = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await StatisticsApiService.getAdminBusinessStatistics();
      setStatistics(response);
    } catch (err) {
      setError('Failed to load statistics. Please try again.');
      console.error('Error fetching statistics:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatistics();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
        <p style={{ marginTop: '20px' }}>Loading statistics...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Error"
        description={error}
        type="error"
        showIcon
        action={
          <Button size="small" danger onClick={fetchStatistics}>
            Retry
          </Button>
        }
      />
    );
  }

  return (
    <div className="statistics-dashboard">
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '24px' 
      }}>
        <h2>Business Statistics Dashboard</h2>
        <Button 
          type="primary" 
          icon={<ReloadOutlined />} 
          onClick={fetchStatistics}
          loading={loading}
          className='add-btnw'
        >
          Refresh Data
        </Button>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <OverviewStatsCards data={statistics} />
      </div>

      <Row gutter={[24, 24]}>
        <Col xs={24} xl={12}>
          <CoursesByCategoryCompactChart data={statistics} />
        </Col>
        <Col xs={24} xl={12}>
          <CategoryBarChart data={statistics} />
        </Col>
      </Row>

      <Row gutter={[24, 24]} style={{ marginTop: '24px' }}>
        <Col xs={24}>
          <TrendLineChart data={statistics} />
        </Col>
      </Row>

      <Row gutter={[24, 24]} style={{ marginTop: '24px' }}>
        <Col xs={24}>
          <CategoryDataTable data={statistics} />
        </Col>
      </Row>

    </div>
  );
};

export default StatisticsDashboard; 